import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export function addUTMs(url: string, campaign: string): string {
  const separator = url.includes('?') ? '&' : '?';
  return `${url}${separator}utm_source=landing&utm_medium=web&utm_campaign=${campaign}`;
}
